import {
    Text,
    Button,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    // CheckboxGroup,
    Input,
    FormControl,
    FormLabel,
    Select,
    // TableContainer,
    // IconButton,
  } from "@chakra-ui/react";
  
  import React, { useEffect, useState } from "react";
  
  export default function LLMConfigAlert({ disclosure }) {
    const [apiKey, setAPIKey] = useState(null);
    const [model, setModel] = useState("gpt-4o-mini");
    const [url, setURL] = useState("http://api.openai.com/v1");
    
    useEffect(() => {
        if (disclosure.isOpen) {
            setAPIKey(localStorage.getItem('ai_api_key'));
            setModel(localStorage.getItem('ai_model'));
            setURL(localStorage.getItem('ai_url'));
        } else {
            setAPIKey("");
            setModel("gpt-4o-mini");
            setURL("http://api.openai.com/v1");
        }
    }, [disclosure.isOpen]);
    return (
      <AlertDialog
        // size={""}
        isOpen={disclosure.isOpen}
        onClose={() => {
            setAPIKey("");
            disclosure.onClose()
        }}
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
                AI Assistant Configuration
            </AlertDialogHeader>
  
            <AlertDialogBody>
              <FormControl mt={4}>
                <FormLabel>Model</FormLabel>
                <Select value={"gpt-4o-mini"} onChange={(e) => {
                    setModel(e.target.value);

                    if (e.target.value && e.target.value.length > 0) {
                      // localStorage.setItem('ai_model', e.target.value);

                      if (e.target.value === "gpt-4.5-preview" || e.target.value === "gpt-4.5-mini" || e.target.value === "o1" || e.target.value === "o3-mini") {
                        setURL("http://api.openai.com/v1");
                        // localStorage.setItem('ai_url', "http://api.openai.com/v1");
                      } else if (e.target.value === "deepseek-chat" || e.target.value === "deepseek-reasoner") {
                        setURL("https://api.deepseek.com");
                        // localStorage.setItem('ai_url', "https://api.deepseek.com");
                      }
                    }

                }}>
                    <option value={"gpt-4.5-preview"}>GPT 4.5 Preview</option>
                    <option value={"gpt-4o-mini"}>GPT 4o mini</option>
                    <option value={"o1"}>GPT o1</option>
                    <option value={"o3-mini"}>GPT o3 mini</option>
                    <option  value={"deepseek-chat"}>DeepSeek V3</option>
                    <option  value={"deepseek-reasoner"}>DeepSeek R1</option>
                </Select>
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>API Key</FormLabel>
                <Input
                  placeholder={"sk-..." }
                  value={apiKey}
                  onChange={(e) => {
                    setAPIKey(e.target.value ? e.target.value : null);
                  }}
                  onKeyDown={(e) => {
  
                    if (e.code === 'Enter') {
                      
                      if (apiKey && apiKey.length > 0) {
                        localStorage.setItem('ai_api_key', apiKey);
                      } else {
                        localStorage.removeItem('ai_api_key');
                      }

                      if (url && url.length > 0) {
                        localStorage.setItem('ai_url', url);
                      } else {
                        localStorage.removeItem('ai_url');
                      }

                      if (model && model.length > 0) {
                        localStorage.setItem('ai_model', model);
                      } else {
                        localStorage.removeItem('ai_model');
                      }

                      disclosure.onClose();

                    }
                  }}
                />
              </FormControl>
            </AlertDialogBody>
  
            <AlertDialogFooter>
              <Button
                mr={4}
                colorScheme={"red"}
                onClick={() => {
                    disclosure.onClose();
                }}
              >
                Cancel
              </Button>
  
              <Button
                mr={4}
                colorScheme={"green"}
                onClick={() => {
                    if (apiKey && apiKey.length > 0) {
                        localStorage.setItem('ai_api_key', apiKey);
                    } else {
                        localStorage.removeItem('ai_api_key');
                    }
                    disclosure.onClose();
                }}
              >
                Save
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    );
  }
  